import React, { useState, useEffect } from "react";
import axios from "axios";
import Swal from "sweetalert2";
import "../../../styles/MBABatch.css";
import { getPresentationsDetailsList, savePresentationsDetailsList } from "../../../services/getAllApi";


const PresentionsTable = ({ students, onPresentationsDataChange}) => {
  // const [students, setStudents] = useState([]); // Store student details
  const [formData, setFormData] = useState({}); // Store fee details

  // Fetch student data from backend
  const fetchPresentationDetails = async () => {
    try {
      const presentationresponse = await getPresentationsDetailsList();

      const initialData = {};
      students.forEach((student) => {
        const presentationsdata = presentationresponse.find((presentationtable) => presentationtable.student_id === student.student_id) || {};
        initialData[student.student_id] = {
          name: presentationsdata.name || student.name ||"",
          // presentation1: presentationsdata.presentation1 || "", 
          presentation1_date: presentationsdata.presentation1_date || "",
          presentation1_status: presentationsdata.presentation1_status || "Pending",
          // presentation2: presentationsdata.presentation2 || "",
          presentation2_date: presentationsdata.presentation2_date || "",
          presentation2_status: presentationsdata.presentation2_status || "Pending",
          // presentation3: presentationsdata.presentation3 || "",
          presentation3_date: presentationsdata.presentation3_date || "",
          presentation3_status: presentationsdata.presentation3_status || "Pending",
          // presentation4: presentationsdata.presentation4 || "",
          presentation4_date: presentationsdata.presentation4_date || "",
          presentation4_status: presentationsdata.presentation4_status || "Pending",
          // presentation5: presentationsdata.presentation5 || "",
          presentation5_date: presentationsdata.presentation5_date || "",
          presentation5_status: presentationsdata.presentation5_status || "Pending",
          // presentation6: presentationsdata.presentation6 || "",
          presentation6_date: presentationsdata.presentation6_date || "",
          presentation6_status: presentationsdata.presentation6_status || "Pending",
        };
      });

      setFormData(initialData);
      onPresentationsDataChange(initialData);
    } catch (error) {
      console.error("Error fetching student data:", error);
    }
  };

  // Call fetchStudents inside useEffect
  useEffect(() => {
    fetchPresentationDetails();
  }, []);

    useEffect(() => {
      onPresentationsDataChange(formData); // ✅ Sync with parent on every update
    }, [formData]);


  // Handle input changes
  const handleChange = (e, student_id) => {
    const { name, value, type, checked } = e.target;
    setFormData({
      ...formData,
      [student_id]: {
        ...formData[student_id],
        [name]: type === "checkbox" ? checked : value,
      },
    });
  };

  const handleSubmit = async () => {
      // const PresentationsDataArray = Object.keys(formData).map((student_id) => {
        // const student = students.find((s) => s.student_id === student_id);
      //   return {
      //     student_id: student_id.toString(), // ✅ match DB type
      //     // name: students.find(s => s.student_id === student_id)?.name || "",
      //     ...formData[student_id],
      //   };
      // });
      const PresentationsDataArray = students.map((student) => {
      // const student = students.find((s) => s.student_id === student_id);
      return {
        student_id: student.student_id.toString(), // ✅ match DB type
        name: formData[student.student_id]?.name || student.name || "",
        presentation1_date: formData[student.student_id]?.presentation1_date || "",
        presentation1_status: formData[student.student_id]?.presentation1_status || false,
        presentation2_date: formData[student.student_id]?.presentation2_date || "",
        presentation2_status: formData[student.student_id]?.presentation2_status || false,
        presentation3_date: formData[student.student_id]?.presentation3_date || "",
        presentation3_status: formData[student.student_id]?.presentation3_status || false,
        presentation4_date: formData[student.student_id]?.presentation4_date || "",
        presentation4_status: formData[student.student_id]?.presentation4_status || false,
        presentation5_date: formData[student.student_id]?.presentation5_date || "",
        presentation5_status: formData[student.student_id]?.presentation5_status || false,
        presentation6_date: formData[student.student_id]?.presentation6_date || "",
        presentation6_status: formData[student.student_id]?.presentation6_status || false,
          // ...formData[student_id],
      };
    });
  
  
      console.log("Submitting Data:", PresentationsDataArray);
  
      try {
        await savePresentationsDetailsList(PresentationsDataArray);
        Swal.fire("Success", "Presentations Data saved successfully!", "success");
        await fetchPresentationDetails();
      } catch (error) {
        Swal.fire("Error", "Failed to save data", "error");
      }
  };


  return (
    <div>
      <button onClick={handleSubmit} className="handle-btn">
        <p className="button-save">Save Data</p>
      </button>
      <div className="table-container-MBA-Students-list">

        <table>
          <thead>
            <tr>
              <th>Sr No.</th>
              <th>Student ID</th>
              <th>Name</th>
              <th>Presentation1</th>
              <th>Presentation2</th>
              <th>Presentation3</th>
              <th>Presentation4</th>
              <th>Presentation5</th>
              <th>Presentation6</th>
            </tr>
          </thead>
          <tbody>
            {students.map((student, index) => (
              <tr key={student.id}>
                <td>{index + 1}</td>
                <td>{student.student_id}</td>
                <td>{student.name}</td>
                {[
                  { dateField: "presentation1_date", checkField: "presentation1_status" },
                  { dateField: "presentation2_date", checkField: "presentation2_status" },
                  { dateField: "presentation3_date", checkField: "presentation3_status" },
                  { dateField: "presentation4_date", checkField: "presentation4_status" },
                  { dateField: "presentation5_date", checkField: "presentation5_status" },
                  { dateField: "presentation6_date", checkField: "presentation6_status" }
                ].map((presentationtable, idx) => (
                  <td key={idx}>
                    <div style={{
                      display: "flex",
                      flexDirection: "column",
                      alignItems: "center",
                      gap: "5px",
                      padding: "5px"
                    }}>
                      {/* <input
                      type="number"
                      name={presentationtable.field}
                      value={formData[student.id]?.[presentationtable.field] || ""}
                      onChange={(e) => handleChange(e, student.id)}
                      style={{ width: "120px", textAlign: "center" }}
                    /> */}
                      <input
                        type="date"
                        name={presentationtable.dateField}
                        value={formData[student.student_id]?.[presentationtable.dateField] || ""}
                        onChange={(e) => handleChange(e, student.student_id)}
                        style={{ width: "120px", textAlign: "center" }}
                      />

                      <select
                        name={presentationtable.checkField}
                        value={formData[student.student_id]?.[presentationtable.checkField] || "Pending"}
                        onChange={(e) => handleChange(e, student.student_id)}
                        style={{
                          width: "120px",
                          textAlign: "center",
                          cursor: "pointer",
                          padding: "5px",
                          fontWeight: "bold",
                          borderRadius: "5px",
                          border: "1px solid #ccc",
                          backgroundColor:
                            formData[student.student_id]?.[presentationtable.checkField] === "Completed"
                              ? "green"
                              : formData[student.student_id]?.[presentationtable.checkField] === "Ongoing"
                                ? "orange"
                                : "red",
                          color: "white",
                        }}
                      >
                        <option value="Pending" style={{ backgroundColor: "red", color: "white" }}>Pending</option>
                        <option value="Ongoing" style={{ backgroundColor: "orange", color: "white" }}>Ongoing</option>
                        <option value="Completed" style={{ backgroundColor: "green", color: "white" }}>Completed</option>
                      </select>
                    </div>
                  </td>
                ))}
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default PresentionsTable;

